/* eslint react/no-array-index-key: 0 */
import React from "react";

import { Formik, FormikValues } from "formik";

import { getInitialValues, getValidationSchema } from "./utils/extensions";
import { IFormFactoryData } from "./utils/types";

import { Container, Row } from "./styles";
import Callinputs from "./call-inputs";
import { ErrorMsg } from "../../ui";

interface IProps {
  data: IFormFactoryData[];
  onSubmit: (values: FormikValues) => void | Promise<void>;
  backButton?: React.ReactNode;
  children?: React.ReactNode;
  setData?: (values: FormikValues) => void;
  initialData?: FormikValues;
  setUpdateFormValues?: (
    updateFn: (values: FormikValues) => FormikValues,
  ) => void;
  submitErrorMessage?: string;
  optionsExtra?: Record<string, any>;
  onlyView?: boolean;
}

const FormFactory: React.FC<IProps> = ({
  data,
  onSubmit,
  backButton,
  children,
  setData,
  initialData,
  setUpdateFormValues,
  submitErrorMessage = "",
  optionsExtra,
  onlyView,
}) => {
  const validationSchema = getValidationSchema(data);
  const initialValues = initialData || getInitialValues(data);

  const options = {
    enableReinitialize: true,
    initialValues,
    onSubmit,
    backButton,
  };

  if (validationSchema) Object.assign(options, { validationSchema });

  return (
    <>
      <Formik {...options}>
        {(actions) => (
          <>
            {children ||
              data.map(({ items }, idx: number) => (
                <Container key={idx}>
                  {items
                    .filter((item) => item.component)
                    .map(({ ...item }, index: number) => (
                      <Row key={`${idx}-${index}`}>
                        <Callinputs
                          {...item}
                          {...actions}
                          setData={setData}
                          setUpdateFormValues={setUpdateFormValues}
                          onlyView={onlyView}
                          optionsExtra={optionsExtra}
                          component={item.component}
                        />
                      </Row>
                    ))}
                </Container>
              ))}
          </>
        )}
      </Formik>
      <ErrorMsg>{submitErrorMessage}</ErrorMsg>
    </>
  );
};

export default FormFactory;
